import {
  AttachCircle,
  Edit,
  Refresh2,
  SearchNormal,
  Send,
} from "iconsax-react";
import React, { useEffect, useState } from "react";
import instance from "../../../axios/instance";
import { getToken } from "../../../utils/token";
import { Autocomplete, TextField } from "@mui/material";
import EditPatientModal from "../EditPatientModal";
import { useRevalidator } from "react-router-dom";

export const TextMessageItem = ({
  onClose,
  dbMessages,
  isNewMessage,
  dbPatients,
}) => {
  const [messages, setMessages] = useState(dbMessages);
  const [message, setMessage] = useState("");
  const [patients, setPatients] = useState(dbPatients);
  const [patient, setPatient] = useState({ label: "", value: "", id: "" });
  const [editPatient, setEditPatient] = useState(null);
  const token = getToken();
  const revalidator = useRevalidator();

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleAttach = (e) => {
    const file = e.target.files[0];
    // console.log(file);
    if (file) {
      setSelectedFile(file);
      setShowModal(true);
    }
  };

  useEffect(() => {
    setPatients(dbPatients);
    if (dbPatients.length >= 1 && patient?.id) {
      const pat = dbPatients.find((p) => p.id === patient?.id);
      setPatient({ label: pat.label, value: pat.cell_phone, id: pat.id });
    }
  }, [dbPatients]);

  // useEffect(() => {
  //   if (patients.length >= 1 && patient?.id) {
  //     const pat = patients.find((p) => p.id === patient?.id);
  //     setPatient({ label: pat.label, value: pat.cell_phone, id: pat.id });
  //   }
  // }, [patients]);

  return (
    <>
      <div className={`absolute inset-0 bg-white py-4 rounded-lg px-4`}>
        <div className="flex justify-between items-center pb-3 border-b -mx-4 px-4">
          <div className="flex gap-x-3 items-center">
            <h2>New text message</h2>
          </div>
          <div>
            <button
              className="bg-primary py-2 px-3 shadow-sm rounded-md font-medium text-[14px] text-white"
              onClick={onClose}
            >
              Back
            </button>
          </div>
        </div>
        {/* {isNewMessage && (
          <div className="my-4">
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={patients}
              onChange={(e, val) => setPatient(val)}
              renderInput={(params) => (
                <TextField {...params} required={true} label="Select patient" />
              )}
            />
            {patient?.label && !patient?.value && (
              <div className="flex gap-x-2 mt-4">
                <span className="text-gray-600">
                  There is no cell phone number attached to this patient.
                </span>
                <span
                  className="flex cursor-pointer gap-x-2 text-primary"
                  onClick={() =>
                    setEditPatient(() =>
                      patients.find((pat) => pat.id === patient?.id)
                    )
                  }
                >
                  Edit <Edit size={20} />
                </span>
              </div>
            )}
          </div>
        )} */}
        <div className="max-h-[65vh] overflow-y-scroll pt-10 pb-20 space-y-4">
          <p className="text-xl text-gray-600 font-medium">Coming Soon...</p>
          {messages.map((message, index) => {
            const isSender = message.sender !== "patient";

            return (
              <div
                key={index}
                className={`flex ${isSender ? "justify-end" : "justify-start"}`}
              >
                <div
                  className={`max-w-[75%] px-4 py-2 rounded-lg text-sm ${
                    isSender
                      ? "bg-[#00b0ad] text-white rounded-br-none"
                      : "bg-[#f4f4f4] text-black rounded-bl-none"
                  }`}
                >
                  <span
                    className={`block text-xs ${
                      isSender ? "text-gray-200" : "text-gray-600"
                    } font-medium mb-1`}
                  >
                    {isSender
                      ? `You - ${message.doctorName}`
                      : `Patient - ${message.patientName}`}
                  </span>

                  {message.isFile ? (
                    <div>
                      {message.pending ? (
                        <div className="flex items-center gap-x-2">
                          <span className="">Uploading...</span>
                        </div>
                      ) : (
                        <>
                          {message.file_type.startsWith("image/") ? (
                            <>
                              <img
                                src={`${url}${message.file_path}`}
                                alt="Preview"
                                className="w-full h-auto rounded-md my-2"
                              />
                              {message.file_size && (
                                <span
                                  className={`text-xs ${
                                    isSender ? "text-gray-300" : "text-gray-500"
                                  }`}
                                >
                                  {(message.file_size / 1024 / 1024).toFixed(2)}{" "}
                                  MB
                                </span>
                              )}
                            </>
                          ) : (
                            <div className="flex items-center gap-x-1">
                              <span className="block text-sm font-medium">
                                {getFileType(message.file_type)}
                              </span>
                              {message.file_size && (
                                <span
                                  className={`text-xs ${
                                    isSender ? "text-gray-300" : "text-gray-500"
                                  }`}
                                >
                                  {(message.file_size / 1024 / 1024).toFixed(2)}{" "}
                                  MB
                                </span>
                              )}
                            </div>
                          )}

                          {message.file_path && (
                            <a
                              href={`${url}${message.file_path}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="flex items-center gap-x-1 mb-1 hover:underline w-fit"
                            >
                              {message.file_type &&
                                getFileTypeIcon(
                                  message.file_type,
                                  isSender ? "text-gray-300" : "text-gray-500"
                                )}
                              <span
                                className={`text-sm ${
                                  isSender ? "text-gray-300" : "text-gray-500"
                                }`}
                              >
                                {message.file_name}
                              </span>
                            </a>
                          )}
                        </>
                      )}
                    </div>
                  ) : (
                    <p className="text-sm">{message.msg}</p>
                  )}
                  <span
                    className={`block text-xs ${
                      isSender ? "text-gray-300" : "text-gray-500"
                    } text-right mt-1`}
                  >
                    {new Date(message.created_at).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <form
          onSubmit={handleSubmit}
          className={`absolute bottom-3 right-0 left-0 bg-white grid grid-cols-[22px_auto] gap-x-2 items-center mt-4 mx-4`}
        >
          <label htmlFor="file" className="max-w-[22px] mx-auto" type="button">
            <input
              type="file"
              name="file"
              id="file"
              className="hidden"
              onChange={handleAttach}
              accept=".pdf,.docx,.xlsx,.jpg,.jpeg,.png,.gif,.mp4,.mov,.avi,.mkv,.webm,.mp3,.wav,.m4a"
              disabled={!patient?.value}
            />
            <AttachCircle
              size={22}
              className={`text-[#555] ${
                !patient?.value
                  ? "cursor-not-allowed opacity-40"
                  : "cursor-pointer opacity-100 hover:text-primary "
              }`}
            />
          </label>
          <div className="relative">
            <input
              type="text"
              name="msg"
              id="msg"
              className="h-[50px] w-full block rounded-md border outline-none focus:border-primary px-3 text-sm pr-10 disabled:opacity-40 disabled:cursor-not-allowed"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              autoComplete="off"
              disabled={!patient?.value}
            />
            <button
              type="submit"
              className="absolute right-[1px] bg-[#f4f4f4] hover:bg-primary-light w-[35px] cursor-pointer top-[1px] bottom-[1px] rounded-r-md border-l flex items-center justify-center  disabled:opacity-40 disabled:cursor-not-allowed"
              disabled={!patient?.value}
            >
              <Send size="22" color="#aaa" />
            </button>
          </div>
        </form>
      </div>
      {editPatient && (
        <EditPatientModal
          patient={editPatient}
          triggerRevalidate={() => revalidator.revalidate()}
          onClose={() => setEditPatient(null)}
        />
      )}
    </>
  );
};
